export const pontoType = [
  {
    name: 'ENTRADA',
    value: 'entrada'
  },
  {
    name: 'SAÍDA PARA ALMOÇO',
    value: 'almoco'
  },
  {
    name: 'RETORNO DO ALMOÇO',
    value: 're_almo'
  },
  {
    name: 'INTERVALO',
    value: 'intervalo'
  },
  {
    name: 'RETORNO',
    value: 'return'
  },
  {
    name: 'FIM DO EXPEDIENTE',
    value: 'fim'
  }
]